export enum InstallmentSimulateOperationTypeEnum {
  WITHDRAW = "S",
  PURCHASE = "C"
}

export enum InterestTypeEnum {
  WITH_INTEREST = "S",
  WITHOUT_INTEREST = "N"
}
